import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustMarquee } from "@/components/TrustMarquee";
import { Features } from "@/components/Features";
import { HowItWorks } from "@/components/HowItWorks";
import { TemplateSection } from "@/components/TemplateSection";
import { OrderForm } from "@/components/OrderForm";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { trackVisit } from "@/lib/tracker";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    trackVisit("/");
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#030712] text-slate-100" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <Features />
        <HowItWorks />
        <TemplateSection />
        <OrderForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
